import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FiltersDisplayTopLevelLogicGroupItem from './FiltersDisplayTopLevelLogicGroupItem';
import { OrderedMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersDisplayContent = () => {
  const {
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const conditions = internalDraftValue && internalDraftValue.conditions && OrderedMap.isOrderedMap(internalDraftValue.conditions) ? internalDraftValue.conditions : OrderedMap();
  const logicOperator = internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName;
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "fr-viewer-panel",
    children: conditions.isEmpty() ? null : conditions.valueSeq().map((group, index) => {
      return /*#__PURE__*/_jsx(FiltersDisplayTopLevelLogicGroupItem, {
        logicGroup: group,
        logicGroupIndex: index
        // @ts-expect-error logicOperator might be undefined
        ,
        logicOperator: logicOperator
      }, `${index}-${group.name}`);
    })
  });
};
export default FiltersDisplayContent;